import request from '@/utils/request'

export function getRoomSurchargeListApi(query) {
  return request({
    url: '/config-service/v1/room-surcharge',
    method: 'get',
    params: query
  })
}

export function addRoomSurchargeApi(payload) {
  return request({
    url: '/config-service/v1/room-surcharge',
    method: 'post',
    data: payload
  })
}

export function updateRoomSurchargeApi(payload) {
  return request({
    url: '/config-service/v1/room-surcharge',
    method: 'put',
    data: payload
  })
}

export function deleteRoomSurchargeApi(payload) {
  return request({
    url: '/config-service/v1/room-surcharge',
    method: 'delete',
    data: payload
  })
}

export function getRoomSurchargeDetailApi(params) {
  return request({
    url: `/config-service/v1/room-surcharge/${params.id}`,
    method: 'get'
  })
}
